import { Data_getInstance1t0dcef9cyy8y as Data_getInstance } from './adapter/SaveSlackIntegrationMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { SaveSlackIntegrationMutationSelections_getInstance126fzsxxh634k as SaveSlackIntegrationMutationSelections_getInstance } from './selections/SaveSlackIntegrationMutationSelections.mjs';
import { SaveSlackIntegrationMutation_VariablesAdapter_instance1c85g929fozri as SaveSlackIntegrationMutation_VariablesAdapter_instance } from './adapter/SaveSlackIntegrationMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(saveSlackIntegration) {
        this.y6k_1 = saveSlackIntegration;
      }
      toString() {
        return 'Data(saveSlackIntegration=' + this.y6k_1 + ')';
      }
      hashCode() {
        return this.y6k_1 == null ? 0 : getBooleanHashCode(this.y6k_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.y6k_1 == other.y6k_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.z6k_1 = obj(Data_getInstance());
        this.a6l_1 = (new (Builder())('data', Companion_getInstance().y6g_1)).g46(SaveSlackIntegrationMutationSelections_getInstance().d6l_1).v39();
        this.b6l_1 = 'bd60e2fc51a5eb05ff72feb92a37fd76f39156d11bc99c67d8ace2bc096f60f8';
        this.c6l_1 = 'saveSlackIntegration';
      }
      b6h() {
        return 'mutation saveSlackIntegration($input: SaveSlackIntegrationInput!) { saveSlackIntegration(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var SaveSlackIntegrationMutationClass;
function SaveSlackIntegrationMutation() {
  if (SaveSlackIntegrationMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.e6l_1 = input;
      }
      d6h() {
        return 'bd60e2fc51a5eb05ff72feb92a37fd76f39156d11bc99c67d8ace2bc096f60f8';
      }
      operationId() {
        return this.d6h();
      }
      z49() {
        return Companion_getInstance_0().b6h();
      }
      e6h() {
        return 'saveSlackIntegration';
      }
      operationName() {
        return this.e6h();
      }
      d49(writer, customScalarAdapters, withDefaultValues) {
        SaveSlackIntegrationMutation_VariablesAdapter_instance.f6l(writer, this, customScalarAdapters, withDefaultValues);
      }
      c49() {
        return Companion_getInstance_0().z6k_1;
      }
      toString() {
        return 'SaveSlackIntegrationMutation(input=' + this.e6l_1.toString() + ')';
      }
      hashCode() {
        return this.e6l_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SaveSlackIntegrationMutation()))
          return false;
        if (!this.e6l_1.equals(other.e6l_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SaveSlackIntegrationMutation', VOID, VOID, [Mutation()]);
    SaveSlackIntegrationMutationClass = $;
  }
  return SaveSlackIntegrationMutationClass;
}
//region block: exports
export {
  Data as Data1y07t6g0k0psd,
  SaveSlackIntegrationMutation as SaveSlackIntegrationMutation39ifsawios99y,
};
//endregion

//# sourceMappingURL=SaveSlackIntegrationMutation.mjs.map
